const localStorageKey = 'secrets_shopify_key';
const trackingIndexName = 'shopify_products';

/**
 * Try to get the details from local storage for conversion tracking.
 * We're using a try...catch here to handle any possible exceptions resulting
 * from local storage or JSON parsing.
 */
function trackConversion() {
  var trackedConversion = false;

  try {
    // Get any previously stored data.
    const previousClickItemsString = localStorage.getItem(localStorageKey)
    // If data was found, send a conversion event for those products.
    if (!!previousClickItemsString) {
      const previousClickItems = JSON.parse(previousClickItemsString)
      previousClickItems.forEach((data) => {
        window.aa('convertedObjectIDsAfterSearch', data)
        trackedConversion = true;
      })
    }
  } catch (error) {
    // No need to do anything in this scenario.
  }

  // Try to remove the items from local storage.
  try {
    localStorage.removeItem(localStorageKey)
  } catch (error) {
    // No need to do anything in this scenario.
  }

  return trackedConversion;
}

function saveForConversionTracking(data) {
 /**
   * We're using a try, catch here to handle any possible exceptions
   * resulting from local storage or JSON parsing.
   */
  try {
    // Get any data previously stored
    const previousClickItemsString = localStorage.getItem(localStorageKey) || '[]';
    const previousClickItems = JSON.parse(previousClickItemsString);

    var conversionData = data;

    // Changing the event to 'addToCart' from 'click'
    conversionData.eventName = 'addToCart';

    // Removing the `positions` property
    delete conversionData.positions;

    if (! conversionData.queryID) {
      const params = new URLSearchParams(window.location.search);
      let windowParams = {}

      for (const [key, value] of params) {
        if (windowParams[key])
          windowParams[key].push(value)
        else
          windowParams[key] = [value]
      }

      if (! windowParams.queryID) {
        throw 'Missing query ID';
      }

      conversionData.queryID = windowParams.queryID;
    }

    // Add the current products data to local storage
    previousClickItems.push(conversionData)
    localStorage.setItem(localStorageKey, JSON.stringify(previousClickItems))
  } catch (error) {
    // No need to do anything in this scenario
  }
};


function trackEvent(eventName, objectIDs, eventType) {
  try {
    let userToken;
    window.aa('getUserToken', null, (err, newUserToken) => {
      if (err) {
        console.error(err);
        return;
      }
      userToken = newUserToken;
    });

    window.aa(eventType, {
        userToken: userToken,
        index: trackingIndexName,
        eventName: eventName,
        objectIDs: objectIDs,
    });
  } catch (error) {
    // No need to do anything in this scenario.
  }
}

